// extracted by mini-css-extract-plugin
export default {"container":"Vz-z","dimension":"Wz-z","dimensionLabels":"Xz-z"};